import { AfterContentInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogFullScreenComponentContent } from '../../models/dialogs/dialog-full-screen';
import { LoginWraperService } from '../../services/login.wraper.service';

@Component({
    selector: 'hub-base-registration',
    templateUrl: 'hub-base-registration.component.html',
    styleUrls: ['hub-base-registration.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class HubBaseRegistrationComponent extends DialogFullScreenComponentContent implements OnDestroy, OnInit, AfterContentInit {

    public pendingSubmit = false;
    private toroForms = (document as any).toroForms;

    constructor(
        private elementRef: ElementRef,
        private dialogReference: MatDialogRef<HubBaseRegistrationComponent>,
        private loginWraperService: LoginWraperService,

        @Inject(MAT_DIALOG_DATA)
        public data: any,
    ) {
        super(elementRef);
    }

    public ngOnInit() {

        super.ngOnInit();

        $('.modal-base-registration')
            .css({ 'margin-top': '200vh' })
            .animate({'margin-top': 0});
    }

    public ngAfterContentInit() {

        // Registra o formulário do tipo toro-form
        this.toroForms.registerForms();
    }

    public ngOnDestroy() {
        this.dispose();
    }

    /**
     * Fecha a modal de cadastro e abre a gaveta de login
     */
    public showLoginPanel() {
        this.dispose()
            .subscribe(() => {
                this.loginWraperService.navigateToLogin();
            });
    }

    /**
     * Verifica se um input é válido
     *
     * @param fieldId
     */
    public isValidField(fieldId: string) {

        if (!this.toroForms.registeredForms[0]) return true;

        const field = this.toroForms.registeredForms[0].querySelector(`[data-field="${fieldId}"]`);
        return field.schema.valid || !field.schema.errors.length;
    }

    /**
     * Método a ser executado ao submeter o form
     */
    public submitRegister() {

        // Remover pending do botão
        const form: HTMLFormElement = this.toroForms.registeredForms[0];

        form.addEventListener('submit', () => this.pendingSubmit = form.valid);
        form.addEventListener('submitError', () => this.pendingSubmit = false);

    }

    /**
     * Fecha a modal de cadastro
     */
    public dispose(afterClose: VoidFunction = null) {

        $('.modal-base-registration')
            .animate({ 'margin-top': '200vh' });

        this.dialogReference.close();
        setTimeout(() => super.close(this.dialogReference, null), 500);

        return this.dialogReference.afterClosed();
    }
}
